// Snackbar Variant
export const SNACKBAR_VARIANT = {
  SUCCESS: "success",
  INFO: "info",
  WARNING: "warning",
  ERROR: "error",
};

// Common error message config
export const ERROR_MESSAGE = {
  INTERNET_ERROR:
    "No internet connection, Please check your connection and try again.",
  SOMETHING_WENT_WRONG: "Something went wrong, please try again.",
  FAILED_TO_FETCH_DATA: "Failed to fetch data.",
};

export const FORM_VALIDATIONS = {
  TEXT_INPUT: {
    REGEX: {
      // eslint-disable-next-line no-useless-escape
      INITIAL: /^(?![0-9!@#$%^&*()_+\-=\[\]{};':"\\|,.<>/?`~]).*$/,
      // eslint-disable-next-line no-useless-escape
      SECONDARY: /^(?!^\d+$)[A-Za-z0-9,\/()\-_.&]*$/,
    },
    MESAAGE: {
      INITIAL: "Invalid input",
      SECONDARY: "Invalid input",
    },
  },

  WC_ESIC_INPUT: {
    // eslint-disable-next-line no-useless-escape
    REGEX: /^(?![!@#$%^&*()_+\-=\[\]{};':"\\|,.<>/?~]).*$/,
    MESSAGE: "Invalid input",
  },

  NUMBER_INPUT: {
    // eslint-disable-next-line no-useless-escape
    REGEX: /^\d{10,}$/, //  /^\d{10}$/ - Previous,
    MESAAGE: "Only Digits are allowed (At least 10)", //"Only 10-digit numbers are allowed",
  },

  MIN_NO_OF_LABOUR: {
    REGEX: /^\d{1,2}$/,
    MESSAGE: "Maximum 2 digits are allowed",
    NON_ZERO_REGEX: /^[1-9]\d*$/,
    NON_ZERO_REGEX_MESSAGE: "Labours must be more than 0",
  },

  PASSWORD: {
    // REGEX: /^[^\s]*$/,
    VALIDATION: [
      {
        regex: /^.{6,}$/,
        message: "Password length at least be 6 characters.",
      },
      {
        regex: /(?=.*[A-Z])/,
        message: "Include an uppercase letter.",
      },
      {
        regex: /(?=.*[a-z])/,
        message: "Include a lowercase letter.",
      },
      {
        regex: /(?=.*\d)/,
        message: "Include a number.",
      },
      {
        regex: /(?=.*[@$!%*?&])/,
        message: "Include a special character.",
      },
      {
        regex: /^\S*$/,
        message: "Password should not contain any spaces.",
      },
    ],

    //Old regex to check any spaces
    // REGEX: /^[^\s]*$/,
    // MESSAGE: "Password should not contain only spaces",

    // New regex to check for only spaces
    REGEX: /^(?=.*\S).{1,}$/,
    MESSAGE: "Password should not consist of only spaces",
  },

  EMAIL: {
    // REGEX: /^[^\s]*$/ //Old regex,
    // MESSAGE: "Email id should not contain any spaces", // Old messess
    REQUIRED: "Email is required",
    VALIDATIONS: [
      {
        regex: /.+@.+\..+/,
        message: "Email must contain '@' and a valid domain.",
      },
      {
        regex: /^[^@]+@[^@]+\.[^@]+$/,
        message: "Email can't start or end with '@' or a dot.",
      },
      {
        regex: /^(?!.*\.\.)/,
        message: "Email can't have two dots in a row.",
      },
      {
        regex: /@[a-zA-Z0-9-]+\./,
        message: "Email must have a valid domain name (example.com).",
      },
      {
        regex: /\.[a-zA-Z]{2,}$/,
        message: "Email should ends with at least 2 letters (.uk .com, .org).",
      },
      {
        regex: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9-]+\.[a-zA-Z]{2,}$/,
        message: "Invalid email format.",
      },
    ],
  },

  UNIQUE_PREFIX: {
    REGEX: /^[A-Z]{3}$/,
    MESSAGE: "Only 3 alphabetic characters are allowed",
  },

  LOCATION_NAME_PERFIX: {
    REGEX: /^(?=.*[A-Z])[A-Z0-9]{3}$/,
    MESSAGE: "Only 3 alphabets or alphanumeric characters are allowed",
  },
};

export const USE_FORMIK_SCHEMA = {
  // Daily Contents
  DAILY_SHLOKA: {
    SHLOKA_TEXT: "Enter shloka content or text",
    SHLOKA_MEANING: "Enter shloka meaning",
    SCHEDULED_DATE: "Select scheduled date",
    CONTENT_LANGUAGE: "Select language",
  },
  DAILY_QUOTE: {
    QUOTE_TEXT: "Enter quote content or text",
    AUTHOR_SOURCE: "Enter author or source",
    SCHEDULED_DATE: "Select scheduled date",
    CONTENT_LANGUAGE: "Select language",
  },
  NEWS: {
    TITLE: "Enter news headline",
    CONTENT: "Enter content for news",
    SCHEDULED_AT: "Select publish date",
    CONTENT_LANGUAGE: "Select language",
  },
  INFORMATION: {
    TITLE: "Enter information headline",
    CONTENT: "Enter content for information",
    CONTENT_LANGUAGE: "Select language",
    HYZYNE_LINK: "Enter heyzine embeded code or link",
  }
};


export const APP_MESSAGE = {
  AUTHENTICATION: {
    INVALID_USER: "Invalid user details provided.",
    FAILED_TO_FETCH: "Unable to fetch user details, please try again.",
    ERROR: "An error occurred while fetching user details.",
  },

  USER_MANAGEMENT: {
    UPDATE_USER_ROLE: {
      SUCCESS: "User role has been updated successfully.",
      FAILED: "Failed to update user role.",
    },
    FETCH: {
      SUCCESS: "Users fetched successfully.",
      FAILED: "Failed to fetch users.",
      NO_USERS: "There are no users found.",
    },
  },

  DAILY_SHLOKA: {
    CREATE: {
      SUCCESS: "Daily shloka is created successfully.",
      FAILED: "Failed to create daily shloka.",
    },
    UPDATE: {
      SUCCESS: "Daily shloka has been updated successfully.",
      FAILED: "Failed to update daily shloka.",
    },
    FETCH: {
      SUCCESS: "Daily shlokas fetched successfully.",
      FAILED: "Failed to fetch daily shlokas.",
      NO_SHLOKAS: "There are no shlokas found.",
    },
  },

  DAILY_QUOTE: {
    CREATE: {
      SUCCESS: "Daily quote is created successfully.",
      FAILED: "Failed to create daily quote.",
    },
    UPDATE: {
      SUCCESS: "Daily quote has been updated successfully.",
      FAILED: "Failed to update daily quote.",
    },
    FETCH: {
      SUCCESS: "Daily quotes fetched successfully.",
      FAILED: "Failed to fetch daily quotes.",
      NO_QUOTES: "There are no quotes found.",
    },
  },

  NEWS_MANAGEMENT: {
    CREATE: {
      SUCCESS: "Devotional news is created successfully.",
      FAILED: "Failed to create devotional news.",
    },
    UPDATE: {
      SUCCESS: "Devotional news has been updated successfully.",
      FAILED: "Failed to update devotional news.",
    },
    CONTENT_PUBLISH: {
      PUBLISH: {
        SUCCESS: "Devotional news published successfully.",
        FAILED: "Failed to publish devotional news.",
      },
      UNPUBLISH: {
        SUCCESS: "Devotional news unpublished successfully.",
        FAILED: "Failed to unpublish devotional news.",
      },
    },
    FETCH: {
      SUCCESS: "News fetched successfully.",
      FAILED: "Failed to fetch devotional news.",
      NO_USERS: "There are no news found.",
    },
  },

  INFORMATION_MANAGEMENT: {
    CREATE: {
      SUCCESS: "Information is created successfully.",
      FAILED: "Failed to create information.",
    },
    UPDATE: {
      SUCCESS: "Information has been updated successfully.",
      FAILED: "Failed to update information.",
    },
    CONTENT_PUBLISH: {
      PUBLISH: {
        SUCCESS: "Information published successfully.",
        FAILED: "Failed to publish information.",
      },
      UNPUBLISH: {
        SUCCESS: "Information unpublished successfully.",
        FAILED: "Failed to unpublish information.",
      },
    },
    FETCH: {
      SUCCESS: "Information fetched successfully.",
      FAILED: "Failed to fetch devotional information.",
      NO_DATA: "There are no information found.",
    },
  },

  FAVORITES: {
    ADD: {
      SUCCESS: "Content added to favorites successfully.",
      FAILED: "Failed to add content to favorites.",
    },
    REMOVE: {
      SUCCESS: "Content removed from favorites successfully.",
      FAILED: "Failed to remove content from favorites.",
    },
  },

  CROSS_TAB_LOGOUT: {
    MESSAGE: "You have been logged out from another tab",
  },

  WORD_COMPLETION_GAME: {
    FETCH: {
      PASSAGE: {
        SUCCESS: "Active passage fetched successfully.",
        FAILED: "Failed to fetch active passage.",
      },
      LEADERBOARD: {
        SUCCESS: "Leaderboard fetched successfully.",
        FAILED: "Failed to fetch leaderboard.",
      },
      GAME_SESSION: {
        SUCCESS: "Game session fetched successfully.",
        FAILED: "Failed to fetch game session.",
      },
      GAME_SESSION_COMPLETE: {
        SUCCESS: "Game session completed successfully.",
        FAILED: "Failed to complete game session.",
      },
    },
  },

  AUTH_ERRORS: {
    POPUP_CLOSED_BY_USER: "Sign-in cancelled. Please try again if you want to continue.",
    POPUP_BLOCKED: "Sign-in popup was blocked by your browser. Please allow popups and try again.",
    NETWORK_ERROR: "Network error occurred. Please check your internet connection and try again.",
    INVALID_CREDENTIALS: "Invalid credentials provided. Please try again.",
    ACCOUNT_EXISTS_WITH_DIFFERENT_CREDENTIAL: "An account already exists with the same email address but different sign-in credentials.",
    EMAIL_ALREADY_IN_USE: "An account with this email address already exists.",
    WEAK_PASSWORD: "Password is too weak. Please choose a stronger password.",
    USER_NOT_FOUND: "No account found with this email address.",
    WRONG_PASSWORD: "Incorrect password. Please try again.",
    TOO_MANY_REQUESTS: "Too many failed attempts. Please try again later.",
    USER_DISABLED: "This account has been disabled. Please contact support.",
    OPERATION_NOT_ALLOWED: "This sign-in method is not allowed. Please contact support.",
    INVALID_EMAIL: "Invalid email address format.",
    REQUIRES_RECENT_LOGIN: "This operation requires recent authentication. Please sign in again.",
    DEFAULT_ERROR: "An unexpected error occurred. Please try again.",
  },
};